import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { classnames } from '@@client/lib/classes';
export default function SectionHeader(_ref) {
  var number = _ref.number,
      disabled = _ref.disabled,
      children = _ref.children,
      _ref$showEdit = _ref.showEdit,
      showEdit = _ref$showEdit === void 0 ? false : _ref$showEdit,
      _ref$onEditClick = _ref.onEditClick,
      onEditClick = _ref$onEditClick === void 0 ? function () {} : _ref$onEditClick,
      _ref$editTitle = _ref.editTitle,
      editTitle = _ref$editTitle === void 0 ? null : _ref$editTitle,
      _ref$editTitleShort = _ref.editTitleShort,
      editTitleShort = _ref$editTitleShort === void 0 ? 'Edit' : _ref$editTitleShort,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
  var className = classnames('container', disabled ? 'is-disabled' : 'is-enabled', isOpen ? 'is-open' : 'not-open');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-1981594" + " " + (className || ""),
      children: [/*#__PURE__*/_jsxs("h3", {
        className: "jsx-1981594",
        children: [number ? /*#__PURE__*/_jsx("span", {
          className: "jsx-1981594" + " " + 'number',
          children: number
        }) : null, children]
      }), disabled || !showEdit ? null : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("button", {
          onClick: onEditClick,
          className: "jsx-1981594" + " " + 'edit-full m--as-link',
          children: ["(", editTitle, ")"]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: onEditClick,
          className: "jsx-1981594" + " " + 'edit-short m--as-link',
          children: ["(", editTitleShort || editTitle, ")"]
        })]
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1981594",
      children: [".container.jsx-1981594{display:grid;grid-auto-flow:column;padding-bottom:10px;margin-bottom:20px;border-bottom:1px solid #9BA3C3;}", ".container.not-open.jsx-1981594,.container.is-disabled.jsx-1981594{border-bottom:0;margin-bottom:0;padding-bottom:0;}", ".container.is-disabled.jsx-1981594{opacity:0.5;}", "h3.jsx-1981594{text-transform:uppercase;color:#21409A;font-size:1.125rem;margin:0;padding:0;}", "button.jsx-1981594{text-align:right;font-size:0.875rem;}", "@media(max-width:575px){.edit-full.jsx-1981594{display:none;}}", "@media(min-width:576px){.edit-short.jsx-1981594{display:none;}}", ".number.jsx-1981594{display:inline-block;border-radius:50%;border:1px solid #21409A;width:30px;height:30px;text-align:center;margin-right:15px;}", ".is-disabled.jsx-1981594 .number.jsx-1981594{display:none;}"]
    })]
  });
}